import VInput from '../../GENIO/components/GInput/GInput'

export { VInput }
export default VInput
